<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="rollup-container">
  <div class="rollup-header">
    <h2>Service Detail Rollup</h2>
  </div>

  <!-- FILTERS -->
  <p-panel header="Filters" [toggleable]="true" [collapsed]="false" styleClass="rollup-filters-panel">
    <div class="rollup-filters">
      <div class="filter-field">
        <label>Date Range</label>
        <p-calendar
          [(ngModel)]="dateRange"
          selectionMode="range"
          dateFormat="mm/dd/yy"
          [showIcon]="true"
          appendTo="body"
          placeholder="Select range..."
          (onClose)="applyFilters()">
        </p-calendar>
      </div>
      <div class="filter-field">
        <label>Region</label>
        <p-dropdown
          [options]="[{label: 'All Regions', value: null}, ...regionOptions]"
          [(ngModel)]="regionFilter"
          (onChange)="applyFilters()"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          appendTo="body">
        </p-dropdown>
      </div>
      <div class="filter-field">
        <label>Service Tag</label>
        <p-dropdown
          [options]="[{label: 'All Tags', value: null}, ...serviceTagOptions.map(t => ({label: t, value: t}))]"
          [(ngModel)]="serviceTagFilter"
          (onChange)="applyFilters()"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          appendTo="body">
        </p-dropdown>
      </div>
      <div class="filter-field">
        <label>Quality Grade Range: {{qualityGradeRange[0]}} — {{qualityGradeRange[1]}}</label>
        <p-slider [(ngModel)]="qualityGradeRange" [range]="true" [min]="1" [max]="10" (onSlideEnd)="applyFilters()"></p-slider>
      </div>
    </div>
  </p-panel>

  <!-- 1. PROPERTY SCORECARD -->
  <p-panel header="Property Scorecard" [toggleable]="true" [collapsed]="false" styleClass="rollup-section">
    <p-table [value]="propertyScorecard" styleClass="p-datatable-striped p-datatable-sm"
      [loading]="loading" sortMode="single">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="propertyCode">Property Code <p-sortIcon field="propertyCode"></p-sortIcon></th>
          <th pSortableColumn="completedTaskCount"># Completed <p-sortIcon field="completedTaskCount"></p-sortIcon></th>
          <th pSortableColumn="avgQualityGrade">Avg Quality Grade <p-sortIcon field="avgQualityGrade"></p-sortIcon></th>
          <th pSortableColumn="avgDurationMinutes">Avg Duration (min) <p-sortIcon field="avgDurationMinutes"></p-sortIcon></th>
          <th pSortableColumn="totalCostAMT">Total Cost <p-sortIcon field="totalCostAMT"></p-sortIcon></th>
          <th pSortableColumn="avgOccupiedNightsBetweenServices">Avg Occ. Nights Between Services <p-sortIcon field="avgOccupiedNightsBetweenServices"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td><strong>{{row.propertyCode}}</strong></td>
          <td>{{row.completedTaskCount}}</td>
          <td>
            <span [class]="'quality-badge ' + getQualityClass(row.avgQualityGrade)">
              {{row.avgQualityGrade | number:'1.1-1'}}
            </span>
          </td>
          <td>{{row.avgDurationMinutes | number:'1.0-0'}} min</td>
          <td>{{row.totalCostAMT | currency:'USD'}}</td>
          <td>{{row.avgOccupiedNightsBetweenServices | number:'1.0-0'}} nights</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="6" style="text-align:center; padding:1rem;">No data for selected filters.</td></tr>
      </ng-template>
    </p-table>
  </p-panel>

  <!-- 2. VENDOR SCORECARD -->
  <p-panel header="Vendor Scorecard" [toggleable]="true" [collapsed]="false" styleClass="rollup-section">
    <p-table [value]="vendorScorecard" styleClass="p-datatable-striped p-datatable-sm"
      [loading]="loading" sortMode="single">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="vendorName">Vendor Name <p-sortIcon field="vendorName"></p-sortIcon></th>
          <th pSortableColumn="completedTaskCount"># Completed <p-sortIcon field="completedTaskCount"></p-sortIcon></th>
          <th pSortableColumn="avgQualityGrade">Avg Quality Grade <p-sortIcon field="avgQualityGrade"></p-sortIcon></th>
          <th pSortableColumn="avgDurationMinutes">Avg Duration <p-sortIcon field="avgDurationMinutes"></p-sortIcon></th>
          <th pSortableColumn="totalCostAMT">Total Cost <p-sortIcon field="totalCostAMT"></p-sortIcon></th>
          <th pSortableColumn="totalUnpaid">Total Unpaid <p-sortIcon field="totalUnpaid"></p-sortIcon></th>
          <th pSortableColumn="lastServiceDate">Last Service <p-sortIcon field="lastServiceDate"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>
            <a href="javascript:void(0)" (click)="onViewVendor(row.vendorId)" class="vendor-link">
              {{row.vendorName}}
            </a>
          </td>
          <td>{{row.completedTaskCount}}</td>
          <td>
            <span [class]="'quality-badge ' + getQualityClass(row.avgQualityGrade)">
              {{row.avgQualityGrade | number:'1.1-1'}}
            </span>
          </td>
          <td>{{row.avgDurationMinutes | number:'1.0-0'}} min</td>
          <td>{{row.totalCostAMT | currency:'USD'}}</td>
          <td [class]="row.totalUnpaid > 0 ? 'unpaid-amt' : ''">
            {{row.totalUnpaid | currency:'USD'}}
          </td>
          <td>{{row.lastServiceDate | date:'MM/dd/yyyy'}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="7" style="text-align:center; padding:1rem;">No data for selected filters.</td></tr>
      </ng-template>
    </p-table>
  </p-panel>

  <!-- 3. RECENT COMPLETIONS -->
  <p-panel header="Recent Completions (last 100)" [toggleable]="true" [collapsed]="false" styleClass="rollup-section">
    <p-table [value]="recentCompletions" styleClass="p-datatable-striped p-datatable-sm"
      [loading]="loading" [rows]="100" [paginator]="true">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="completedAt">Date <p-sortIcon field="completedAt"></p-sortIcon></th>
          <th pSortableColumn="propertyCode">Property <p-sortIcon field="propertyCode"></p-sortIcon></th>
          <th pSortableColumn="taskName">Task Name <p-sortIcon field="taskName"></p-sortIcon></th>
          <th pSortableColumn="vendorName">Vendor <p-sortIcon field="vendorName"></p-sortIcon></th>
          <th pSortableColumn="qualityGrade">Quality <p-sortIcon field="qualityGrade"></p-sortIcon></th>
          <th pSortableColumn="actualCostAMT">Cost <p-sortIcon field="actualCostAMT"></p-sortIcon></th>
          <th pSortableColumn="actualDurationMinutes">Duration <p-sortIcon field="actualDurationMinutes"></p-sortIcon></th>
          <th pSortableColumn="occupiedNightsAtCompletion">Occ. Nights @ Complete <p-sortIcon field="occupiedNightsAtCompletion"></p-sortIcon></th>
          <th pSortableColumn="nextServiceDueAtOccupiedNights">Next Due @ <p-sortIcon field="nextServiceDueAtOccupiedNights"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr style="cursor:pointer" (click)="onViewTask(row.taskId)">
          <td>{{row.completedAt | date:'MM/dd/yyyy'}}</td>
          <td>{{row.propertyCode}}</td>
          <td>{{row.taskName}}</td>
          <td>{{row.vendorName}}</td>
          <td>
            <span [class]="'quality-badge ' + getQualityClass(row.qualityGrade)">
              {{row.qualityGrade}}
            </span>
          </td>
          <td>{{row.actualCostAMT | currency:'USD'}}</td>
          <td>{{row.actualDurationMinutes}} min</td>
          <td>{{row.occupiedNightsAtCompletion}}</td>
          <td>{{row.nextServiceDueAtOccupiedNights}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="9" style="text-align:center; padding:1rem;">No completions for selected filters.</td></tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>
